module.exports = __webpack_public_path__ + "img/pro_one_6.cbed1812.jpg";